import { AssistChip, Checkbox, Skeleton, Stack, Text } from '@sixui/ui';

import { AppIcon } from '~/components/atoms/AppIcon';
import { Table } from '~/components/molecules/Table';

export const SearchCommunityListItemSkeleton: React.FC = () => (
  <Table.Row>
    <Table.Body>
      <Skeleton>
        <Checkbox />
      </Skeleton>
    </Table.Body>

    <Stack as={Table.Body} horizontal gap={3}>
      <Skeleton variant="circular">
        <AppIcon />
      </Skeleton>
      <Stack gap={1}>
        <Text
          as={Skeleton}
          variant="title"
          size="sm"
          length={{ min: 8, max: 24 }}
        />
        <Text as={Skeleton} variant="body" size="sm" length={45} />
      </Stack>
    </Stack>

    <Table.Body />

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }}>
        <AssistChip />
      </Skeleton>
    </Table.Body>

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }} />
    </Table.Body>

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }} />
    </Table.Body>

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }} />
    </Table.Body>
  </Table.Row>
);
